import React from 'react';
import { CurrentContentView } from '../../App';

interface NavigationIconProps {
    readonly view: CurrentContentView;
    readonly innerClassName?: string;
}

export const NavigationIcon: React.FC<NavigationIconProps> = ({ view, innerClassName }) => {
    switch (view) {
        case 'dashboard':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M13 21V11h8v10h-8ZM3 13V3h8v10H3Zm6-2V5H5v6h4ZM3 21v-6h8v6H3Zm2-2h4v-2H5v2Zm10 0h4v-6h-4v6ZM13 3h8v6h-8V3Zm2 2v2h4V5h-4Z" />
                    <path opacity=".2" d="M19 13h-5v7h5v-7ZM9 15.5l-5 1.954L4.5 20H10l-1-4.5Z" />
                </svg>
            );
        case 'snips':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="m17.657 14.828-1.414-1.414L17.657 12A4.001 4.001 0 0 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.414Zm-2.83 2.83-1.413 1.413a6 6 0 1 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 1 0 12 17.657l1.414-1.414 1.414 1.414Zm0-9.9 1.416 1.414-7.071 7.07-1.415-1.414 7.07-7.07ZM5.776 2.292l1.932-.518L8.742 5.64l-1.931.518-1.036-3.864Zm9.483 16.068 1.93-.518 1.037 3.864-1.932.518-1.035-3.864ZM2.293 5.775l3.864 1.036-.518 1.931-3.864-1.035.518-1.932Zm16.068 9.483 3.864 1.035-.518 1.932-3.864-1.036.518-1.93Z" />
                    <path
                        opacity=".2"
                        d="M18 13.5 11 6c3-2.5 5.5-2 7.5 0 2.5 2.5.667 5.667-.5 7.5Z"
                    />
                </svg>
            );
        case 'discover-content':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0 0.993C0.00183004 0.730378 0.1069 0.479017 0.292513 0.293218C0.478126 0.107418 0.72938 0.00209465 0.992 0H19.008C19.556 0 20 0.445 20 0.993V17.007C19.9982 17.2696 19.8931 17.521 19.7075 17.7068C19.5219 17.8926 19.2706 17.9979 19.008 18H0.992C0.728813 17.9997 0.476497 17.895 0.290489 17.7088C0.104482 17.5226 -1.33455e-07 17.2702 0 17.007V0.993ZM2 2V16H18V2H2ZM4 4H10V10H4V4ZM6 6V8H8V6H6ZM4 12H16V14H4V12ZM12 4H16V6H12V4ZM12 8H16V10H12V8Z" />
                </svg>
            );
        case 'clipboard':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M17 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H7V0H9V2H15V0H17V2ZM17 4V6H15V4H9V6H7V4H5V20H19V4H17ZM7 8H17V10H7V8ZM7 12H17V14H7V12Z" />
                    <path
                        opacity="0.2"
                        d="M16.5 16.5001L20.5081 6L20.498 6.57159L20.5081 21.149L10.3894 20.813L6 20L16.5 16.5001Z"
                    />
                </svg>
            );
        case 'reporting':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3ZM4 5V19H20V5H4ZM7 13H9V17H7V13ZM11 7H13V17H11V7ZM15 10H17V17H15V10Z" />
                    <path
                        opacity="0.2"
                        d="M16.5 16.0001L20.5081 5.5L20.498 6.07159L20.5081 20.649L10.3894 20.313L6 19.5L16.5 16.0001Z"
                    />
                </svg>
            );
        case 'integrations':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity=".2"
                        d="M12.5 15c3.6-.8 6.167-4.333 7-6v1.5a7 7 0 0 1-7 7H7c.333-.5 1.9-1.7 5.5-2.5Z"
                    />
                    <path d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4V7a1 1 0 0 1 1-1h3V2h2v4h4V2h2v4h3a1 1 0 0 1 1 1v7a4 4 0 0 1-4 4h-3Zm-5-2h8a2 2 0 0 0 2-2v-3H6v3a2 2 0 0 0 2 2Zm10-8H6v1h12V8Zm-6 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" />
                </svg>
            );
        case 'customization':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity=".2"
                        d="M11.5 15.5c-2.8.8-5.2.3-6 0-1 2 0 2.5 0 3s1 1 2.5 0c1.2-.8 1.8-.3 2 0 0 .7.3 2.1 1.5 2.5 1.5.5 2-.5 2-1s.5-1.5 1.5-2c.8-.4 1.3.2 1.5.5H18c.5 0 1.5-.5.5-2-.8-1.2-.3-2.2 0-2.5.5-.2 1.7-.3 2.5-1.5s-1-2-2-2c-1.3 1.3-4.7 4.2-7.5 5Z"
                    />
                    <path d="M12 10.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5ZM8.5 12c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5-3.5-1.6-3.5-3.5Z" />
                    <path d="M12.1 22.2a2.732 2.732 0 0 1-2.7-2.7c0-.1 0-.2-.1-.3 0-.1-.1-.1-.2-.1s-.1-.1-.2 0c-.1 0-.1 0-.2.1-.3.3-.6.5-.9.6-.7.3-1.4.3-2 0-.3-.1-.6-.3-.9-.6-.2-.2-.4-.5-.6-.9-.1-.3-.2-.7-.2-1 0-.4.1-.7.2-1 .1-.3.3-.6.6-.9.1-.1.1-.1.1-.2V15c0-.1-.1-.1-.1-.2-.1 0-.1-.1-.2-.1h-.2A2.732 2.732 0 0 1 1.8 12a2.732 2.732 0 0 1 2.7-2.7c.1 0 .2 0 .3-.1.1 0 .1-.1.1-.2 0 0 .1 0 0-.1 0-.1 0-.1-.1-.2l-.6-.9c-.1-.3-.2-.7-.2-1 0-.3.1-.7.2-1 .1-.3.3-.6.6-.9.2-.2.5-.4.9-.6.6-.3 1.4-.3 2 0 .3.1.6.3.9.6.1.1.1.1.2.1H9c.1 0 .1 0 .2-.1l.1-.1c0-.1.1-.1.1-.2v-.1c0-.7.3-1.4.8-1.9 1-1 2.8-1 3.8 0 .5.5.8 1.2.8 1.9 0 .1 0 .2.1.3 0 .1.1.1.2.1h.2c.1 0 .1 0 .2-.1.3-.3.6-.5.9-.6.6-.3 1.4-.3 2 0 .3.1.6.3.9.6.2.2.4.5.6.9.1.3.2.7.2 1 0 .3-.1.7-.2 1-.1.3-.3.6-.6.9-.3.1-.3.1-.3.2V9c0 .1 0 .1.1.2l.1.1c.1 0 .1.1.2.1h.1a2.732 2.732 0 0 1 2.7 2.7 2.732 2.732 0 0 1-2.7 2.7c-.1 0-.2 0-.3.1-.1 0-.1.1-.1.2v.2c0 .1 0 .1.1.2.3.3.5.6.6.9.1.3.2.7.2 1 0 .4-.1.7-.2 1-.1.3-.3.6-.6.9-.2.2-.5.4-.9.6-.7.3-1.4.3-2 0-.3-.1-.6-.3-.9-.6-.1-.3-.1-.3-.2-.3H15c-.1 0-.1.1-.2.1 0 .1-.1.1-.1.2v.1c0 .7-.3 1.4-.8 1.9-.5.6-1.1.9-1.8.9ZM8.9 17c.3 0 .7.1 1 .2.4.1.8.4 1.1.8.3.4.4.8.4 1.3 0 .3.1.4.2.6.2.2.7.2.9 0 .1-.1.2-.3.2-.5v-.1c0-.5.1-.9.4-1.3.3-.4.6-.7 1-.9.4-.2.9-.2 1.4-.2.5.1.9.3 1.2.6.1.1.2.2.3.2.2.1.3.1.5 0 .1 0 .2-.1.2-.1.1-.1.1-.1.1-.2s.1-.2.1-.3c0-.1 0-.2-.1-.3 0-.1-.1-.2-.1-.2-.4-.4-.6-.8-.7-1.3-.1-.5 0-.9.2-1.4.2-.4.5-.8.9-1 .4-.3.8-.4 1.3-.4.3 0 .4-.1.6-.2.2-.1.2-.3.2-.5s-.1-.3-.2-.5c-.1-.1-.3-.2-.5-.2h-.1c-.5 0-.9-.1-1.3-.4-.4-.3-.7-.6-.9-1 0-.1-.1-.2-.1-.2-.1-.2-.2-.6-.1-1 .1-.5.3-.9.6-1.2.1-.1.2-.2.2-.3 0-.1.1-.2.1-.3 0-.1 0-.2-.1-.3 0-.1-.1-.1-.1-.2-.1-.1-.1-.1-.2-.1-.2-.1-.3-.1-.5 0-.1 0-.2.1-.2.1-.4.4-.8.6-1.3.7-.5.1-.9 0-1.4-.2-.4-.2-.8-.5-1-.9-.3-.4-.4-.8-.4-1.3 0-.3-.1-.4-.2-.5-.3-.2-.7-.2-.9 0-.1.1-.2.3-.2.5v.1c0 .5-.1.9-.4 1.3-.3.4-.6.7-1 .9-.1 0-.2.1-.2.1-.5.1-.9.2-1.3.1-.5-.1-.9-.3-1.3-.7-.1-.1-.2-.1-.3-.2-.2-.1-.3-.1-.5 0-.1 0-.2.1-.2.1s-.1.2-.1.3c-.1.1-.1.2-.1.3 0 0 0 .1.1.2 0 .1.1.2.1.2.4.4.6.8.7 1.3.1.5 0 1-.2 1.4-.1.4-.4.8-.8 1.1-.4.3-.8.4-1.3.4-.3 0-.4.1-.6.2-.2.1-.2.3-.2.5s.1.3.2.5c.1.1.3.2.5.2h.1c.5 0 .9.1 1.3.4.4.3.7.6.9 1 .2.4.3.9.2 1.3-.1.5-.3.9-.6 1.2-.1.1-.2.2-.2.3 0 .1-.1.2-.1.3 0 .1 0 .2.1.3 0 .1.1.2.1.2.1.1.1.1.2.1.2.1.3.1.5 0 .1 0 .2-.1.2-.1.4-.4.8-.6 1.3-.7.2 0 .3-.1.4-.1Z" />
                </svg>
            );
        case 'support':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        opacity="0.2"
                        d="M6.17647 13.4741C5.32941 12.6219 3.70588 12.7639 3 12.9415C3.52941 15.2493 6.07059 20.078 12 20.9302C17.9294 21.7824 20.4706 14.5388 21 10.8105C20.1176 11.1656 18.1412 12.0888 17.2941 12.941C16.2353 14.0062 14.6471 15.0714 12 15.0714C9.35294 15.0714 7.23529 14.5393 6.17647 13.4741Z"
                    />
                    <path
                        d="M14.4971 9.3634L18.2382 5.59961"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4 12C4 10.1112 4.65461 8.3752 5.74933 7.00662L8.17186 9.44379C7.72755 10.1481 7.47058 10.983 7.47058 11.8769C7.47058 12.7706 7.72744 13.6053 8.17156 14.3096L5.64124 16.8552C4.61165 15.5088 4 13.8258 4 12ZM7.0443 18.2806C8.40699 19.3573 10.1284 20 12 20C13.8715 20 15.593 19.3573 16.9557 18.2806L14.4169 15.7265C13.7181 16.1705 12.8896 16.4277 12 16.4277C11.1104 16.4277 10.2819 16.1704 9.58305 15.7265L7.0443 18.2806ZM18.3587 16.8552C19.3883 15.5088 20 13.8258 20 12C20 10.1113 19.3455 8.37546 18.2509 7.00693L15.8283 9.44415C16.2725 10.1484 16.5294 10.9832 16.5294 11.8769C16.5294 12.7706 16.2725 13.6053 15.8284 14.3096L18.3587 16.8552ZM12 4C13.8087 4 15.4772 4.60022 16.8172 5.61235L14.4168 8.02723C13.718 7.58336 12.8895 7.32617 12 7.32617C11.1106 7.32617 10.2822 7.58327 9.58353 8.02701L7.18314 5.61211C8.52308 4.60013 10.1915 4 12 4ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM9.47058 11.8769C9.47058 10.4625 10.6087 9.32617 12 9.32617C13.3913 9.32617 14.5294 10.4625 14.5294 11.8769C14.5294 13.2913 13.3913 14.4277 12 14.4277C10.6087 14.4277 9.47058 13.2913 9.47058 11.8769Z"
                    />
                </svg>
            );

        case 'page':
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="m17.657 14.828-1.414-1.414L17.657 12A4.001 4.001 0 0 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.414Zm-2.83 2.83-1.413 1.413a6 6 0 1 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 1 0 12 17.657l1.414-1.414 1.414 1.414Zm0-9.9 1.416 1.414-7.071 7.07-1.415-1.414 7.07-7.07ZM5.776 2.292l1.932-.518L8.742 5.64l-1.931.518-1.036-3.864Zm9.483 16.068 1.93-.518 1.037 3.864-1.932.518-1.035-3.864ZM2.293 5.775l3.864 1.036-.518 1.931-3.864-1.035.518-1.932Zm16.068 9.483 3.864 1.035-.518 1.932-3.864-1.036.518-1.93Z" />
                    <path
                        opacity=".2"
                        d="M18 13.5 11 6c3-2.5 5.5-2 7.5 0 2.5 2.5.667 5.667-.5 7.5Z"
                    />
                </svg>
            );
        default:
            return (
                <svg
                    className={innerClassName}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M10 18V8h8v10h-8ZM0 10V0h8v10H0Zm6-2V2H2v6h4ZM0 18v-6h8v6H0Zm2-2h4v-2H2v2Zm10 0h4v-6h-4v6ZM10 0h8v6h-8V0Zm2 2v2h4V2h-4Z" />
                </svg>
            );
    }
};
